// Angular
import { Injectable } from '@angular/core';

// Rx
import { BehaviorSubject, Observable, Subject } from 'rxjs';

// Models
import { RefreshEventArgs } from 'app/_models';
import { DataResultIterator } from '@progress/kendo-angular-grid/dist/es2015/data/data.collection';
import { HttpParams } from '@angular/common/http';
import { POLICY_STATUS } from 'app/_constants/policyStatus';


@Injectable()
export class SharedService {
    private emitChangeSource = new Subject<any>();
    private searchDossierListFilterSubject = new BehaviorSubject<any>(null);
    searchDossierListFilter$: Observable<any> = this.searchDossierListFilterSubject.asObservable();
    private mainRouteSubject = new BehaviorSubject<any>(null);
    mainRoute$: Observable<any> = this.mainRouteSubject.asObservable();
    private refreshChangeSource = new Subject<RefreshEventArgs>();

    public changeEmitted$ = this.emitChangeSource.asObservable();

    public refreshEmitted$ = this.refreshChangeSource.asObservable();

    public emitChange(change: any): void {
        this.emitChangeSource.next(change);
    }
    setSearchFilter(filter: any):void {
      this.searchDossierListFilterSubject.next(filter);
    }

    setMainRoute(route: string):void {
      this.mainRouteSubject.next(route);
    }

    public formatObjectToQueryString = (queryObjectParams)=> 
    {        
        let params = new HttpParams();
        const attrs = Object.keys(queryObjectParams); 
        attrs.forEach(attr=> {
            if(queryObjectParams[attr])
            params = params.append(attr,queryObjectParams[attr])
        });
        return params.toString();
    }

    public emitRefresh(type: string): void {
        this.refreshChangeSource.next({ Type: type });
    }
    public hasProperty = (object, key) => {
        return key.split(".").every(function(x) {
        if(typeof object!= "object" || object=== null || !(x in object))
         return false;
         object= object[x];
        return true;
        });
    }

    public isAllAttributesEmptyStringOrNull(obj)
    {
      return Object.keys(obj).every(key=> obj[key] == "" || obj[key] == null);
    }

    public isValidGUID(value: string): boolean {
     let isValid = false;
     if (value && value.length > 0) {
        if ((/^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/).test(value)) {
        isValid = true;
      }
    }
    return isValid;
    }
    
    public checkPermissionByRole (functionnality : string) : any {
        let roles=JSON.parse(localStorage.getItem("CED.ROLES"));
        let result={'hasCreate':false,'functionality':functionnality,'hasEdit':false,'hasRead':false};
        let connectedUserRoles = roles["data"];
        let filtredData = connectedUserRoles.filter(item=>item.authorizationRoleId == functionnality);
        let isCreate = false;
        let isRead =false;
        let isUpdate=false;
        filtredData.forEach(element => {
            isCreate = element.operationCreate || isCreate;
            isRead = element.operationRead || isRead;
            isUpdate = element.operationUpdate || isUpdate;
        });
        if (filtredData.length >0) result = {'hasCreate':isCreate,'functionality':functionnality,'hasEdit':isUpdate,'hasRead':isRead}
        return result;
    }

    getPolicies(policy,insurerAlamrCenters){
        let policyClientData = [];
        let policyInvolvedCoverageData = [];
        if(!!policy){
            if (this.hasProperty(policy,'selectedtravelPolicies')) {
               const {travelPolicyClientData,travelPolicyInvolvedCoverageData} = this.getTravelPolicies(policy.selectedtravelPolicies,insurerAlamrCenters);
               policyClientData = travelPolicyClientData;
               policyInvolvedCoverageData = travelPolicyInvolvedCoverageData;
            }
            if (this.hasProperty(policy,'selectedhealthPolicies')) {
             const {healthPolicyClientData,healthPolicyInvolvedCoverageData} = this.getHealthPolicies(policy.selectedhealthPolicies);
             policyClientData = [...policyClientData,...healthPolicyClientData];
             policyInvolvedCoverageData = [...policyInvolvedCoverageData,...healthPolicyClientData];
            }
            if (this.hasProperty(policy,'noInsurancePolicies')){
            const {noPolicyClientData,noPolicyInvolvedCoverageData} = this.getNoInsurancePolicies(policy);
            policyClientData = [...policyClientData,...noPolicyClientData];
            policyInvolvedCoverageData = [...policyInvolvedCoverageData,...noPolicyInvolvedCoverageData];
            }
          }
          return ({policyClientData,policyInvolvedCoverageData})
    }

    getTravelPolicies(travelPolicies, insurerAlamrCenters){
        let travelPolicyClientData = [];
        let travelPolicyInvolvedCoverageData = [];
        travelPolicies.forEach(travelPolicy => {
        let idInsurer = travelPolicy.insurer ? travelPolicy.insurer : travelPolicy.insurerId;
        let foundInsurer = insurerAlamrCenters.find(a => a.insurerId == idInsurer);
        if (foundInsurer != undefined) {
          let insureeTravelInsurer = {
            text: travelPolicy.productName && travelPolicy.productName.productName  ? foundInsurer.shortName + " - " + travelPolicy.productName.productName : foundInsurer.shortName,
            value: foundInsurer.insurer ? foundInsurer.insurer : foundInsurer.insurerId,
            isHealth: false,
            isTravel: true,
            productId:travelPolicy.productName && travelPolicy.productName.productId  ? travelPolicy.productName.productId : null,
          };
          if (travelPolicy.ptiStatusPolicyCheck == "1" || travelPolicy.ptiStatusPolicyCheck == "4" || travelPolicy.ptiStatusPolicyCheck == "6") {
            travelPolicyClientData = [...travelPolicyClientData, insureeTravelInsurer];
            travelPolicyInvolvedCoverageData = [...travelPolicyInvolvedCoverageData, {"key":insureeTravelInsurer.value+'|'+insureeTravelInsurer.productId ,"value": insureeTravelInsurer.text,"clientId":insureeTravelInsurer.value,"productId":insureeTravelInsurer.productId }];
          }
        }
      });
      return ({travelPolicyClientData,travelPolicyInvolvedCoverageData});
    }

    getHealthPolicies(healthPlicies){
        let healthPolicyClientData = [];
        let healthPolicyInvolvedCoverageData = [];
        healthPlicies.forEach((element) => {
            if (element.vhiInsurer) {
              let insureeHealthInsurer = {
                text: element.vhiPolicyName ? element.vhiInsurer.shortName + " - " + element.vhiPolicyName : element.vhiInsurer.shortName,
                value: element.vhiInsurer.id,
                isHealth: true,
                isTravel: false,
                productId: element.vhiPolicyName ? element.vhiProductId : null
              };
              let vhiStatusPolisCheck = element.vhiStatusPolisCheck;
              if (vhiStatusPolisCheck && (vhiStatusPolisCheck.toLowerCase() == POLICY_STATUS.OK.toLowerCase() || vhiStatusPolisCheck.toLowerCase()== POLICY_STATUS.NOT_APPLICABLE.toLowerCase())) {
                healthPolicyClientData = [...healthPolicyClientData, insureeHealthInsurer];
                healthPolicyInvolvedCoverageData = [...healthPolicyInvolvedCoverageData, {"key":insureeHealthInsurer.value+'|'+insureeHealthInsurer.productId ,"value": insureeHealthInsurer.text,"clientId":insureeHealthInsurer.value,"productId":insureeHealthInsurer.productId }];
              }
            }
          });
          return({healthPolicyClientData,healthPolicyInvolvedCoverageData});
    }

    getNoInsurancePolicies(policy){
        let noPolicyClientData = [];
        let noPolicyInvolvedCoverageData = [];
        policy.noInsurancePolicies.forEach(element => {
            let noInsurancePolicy = {
              text: element.nipCoverageType,
              value: policy.client.id ? policy.client.id : policy.iagCorePartner.id,
              isHealth: false,
              isTravel: false,
              productId: null,
            };
            noPolicyClientData = [...noPolicyClientData, noInsurancePolicy];
            noPolicyInvolvedCoverageData = [...noPolicyInvolvedCoverageData, {"key":noInsurancePolicy.value+'|'+noInsurancePolicy.productId ,"value": noInsurancePolicy.text,"clientId":noInsurancePolicy.value,"productId":noInsurancePolicy.productId }];
          });
          return({noPolicyClientData,noPolicyInvolvedCoverageData});
    }
    getPartyPolicies(parties,insurerAlamrCenters){
        let partyClientData = [];
        let partyInvolvedCoverageData = [];
            parties.forEach(travelPartie => {
              if (travelPartie.ftdTravelInsurances.length > 0) {
                travelPartie.ftdTravelInsurances.forEach(element => {
                  if (element.insurer != undefined && element.insurer != null) {
                    let idInsurer = element.insurer ? element.insurer : element.insurerId;
                    let foundInsurer = insurerAlamrCenters.find(a => a.insurerId == idInsurer);
                    if (foundInsurer != undefined) {
                      let partiesTravelInsurer = {
                        text: foundInsurer.longName,
                        value: foundInsurer.insurer ? foundInsurer.insurer : foundInsurer.insurerId,
                        isHealth: false,
                        isTravel: true,
                        productId: element.productName && element.productId  ? element.productId : null,
                      };
                      if (!partyClientData.find(c => c.value == partiesTravelInsurer.value &&  c.productId == partiesTravelInsurer.productId)) {
                        if (element.ptiStatusPolicyCheck == "1" || element.ptiStatusPolicyCheck == "4" || element.ptiStatusPolicyCheck == "6") {
                            partyClientData = [...partyClientData, partiesTravelInsurer];
                            partyInvolvedCoverageData = [...partyInvolvedCoverageData, {"key":partiesTravelInsurer.value+'|'+partiesTravelInsurer.productId ,"value": partiesTravelInsurer.text,"clientId":partiesTravelInsurer.value,"productId":partiesTravelInsurer.productId }];
                      }
                    }
                    }
                  }
                });
              }
            });
        return ({partyClientData,partyInvolvedCoverageData})
    }
    sanitizeHtml(htmlInput : string) : string
    {
      return htmlInput;
    }
}